export default "__VITE_ASSET__iGLD66Ps__"